import {IncomingCreateListElementType, IncomingCreateType} from "../interface";
import {invDetailInit} from "../../../inv/detail/state";
import moment from "moment";

export const incomingCreateInit: IncomingCreateType = {
    accountName: "",
    changeAt: moment().format("YYYY-MM-DD"),
    code: "",
    createEachIncomingReqList: [],
    memo: ""
}

export const incomingCreateListElementInit: IncomingCreateListElementType = {
    ...invDetailInit,
    changeAmount: 0,
}